import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '100%',
    marginRight: '20px'
  }
}))

export default useStyles
